import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { Container, Box, Typography, Grid, Button } from "@mui/material";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";

function ThankYou(props) {
    const { handleWindowClose,message } = props;

    return (
        <React.Fragment>
            <Container maxWidth="md">
                <Box textAlign="center" sx={{ mt: 12,mb:8 }}>
                    <Box component="img" sx={{ height: "50px" }} src="../Images/wf-logo1.png"></Box>
                </Box>
                <Box sx={{ flexGrow: 1, mb: 5 }}>
                    <Grid
                        container
                        spacing={2}
                        sx={{ border: 1, padding: 5, backgroundColor: "#f8f8f8" }}
                    >
                        <Grid item xs={12} textAlign="center">
                            <LibraryAddCheckIcon fontSize="large" color="primary" />
                        </Grid>
                        <Grid item xs={12} textAlign="center">
                            <Typography variant="h5">{message}</Typography>
                        </Grid>
                        {/* <Grid item xs={12} textAlign="center">
                            <Typography variant="body1" gutterBottom>
                                You'll receive a copy in your inbox once everyone has signed.
                            </Typography>
                        </Grid> */}
                    </Grid>
                </Box>
                <Box textAlign="center">
                    <Button variant="contained" color="error" onClick={handleWindowClose}>
                        Close
                    </Button>
                </Box>
            </Container>
        </React.Fragment>
    );
}

export default ThankYou;